<section class="login">
    <div class="logo">
        <img src="./assets/logo.png" alt="logo">
    </div>
    <div>
        <mat-card>
            <mat-card-content *ngIf="!isMessageShow">
                <form [formGroup]="forgotLoginForm" (ngSubmit)="forgotLoginFormSubmit()">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input type="email" matInput formControlName="email">
                        <i class="material-icons" matSuffix> email </i>
                        <mat-error *ngIf="forgotLoginFormValidate?.email?.errors?.required">
                            This field is required.
                        </mat-error>
                        <mat-error *ngIf="forgotLoginFormValidate?.email?.errors?.email">
                            Please enter valid email.
                        </mat-error>
                    </mat-form-field>
                    <br>
                    <div fxLayout="row" fxLayoutAlign="center">
                        <button type="submit" class="btn-int-blue" mat-raised-button color="primary">Continue</button><br>
                    </div>

                </form>
            </mat-card-content>
            <mat-card-content *ngIf="isMessageShow">
                <form>
                    <div>
                        <h3 class="forMessage">{{ message }}</h3>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center" class="mat-card-actions">
                        <button type="button" [routerLink]="['/login']" mat-button color="primary" matSufix>Go to Home</button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>

</section>